import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const learningPageStyle = {
  container,
  top: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  box:{
    margin:"40px 20px"
  },
  img:{
    maxWidth:"100%"
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#999",
  },
  right:{
    textAlign:"justify !important",
    direction:"ltr"
  },
  left:{
    textAlign:"justify !important",
    direction:"rtl"

  },
  rightAlign :{
    textAlign:"left !important",
  },
  centerAlign :{
    textAlign:"center !important",
  },
  leftAlign:{
    textAlign:"right !important",
  },
  justifyAlign:{
    textAlign:"justify !important",
  },
  cardBtn:{
    width:"100%"
  },
  name: {
    marginTop: "-80px"
  },
  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  divider:{
    marginTop:"20px",
    marginBottom:"20px"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
  fastAccess:{
    direction:"ltr",
    textAlign:"left",
    marginTop:"50px",
    marginBottom:"20px"
  },
  fastAccessButton:{
backgroundColor:"#f50057"
  },
  card:{
    marginBottom:"30px",
  },
  cardContent:{
    padding: "16px 16px 0px 16px"
  },
  cardTitle:{
    minHeight:"100px"
  },
  center:{
    textAlign:"center"
  },
  fullimage:{
    width:"100%",

    margin:"20px auto"
  },
  priceText:{
    "&:disabled": {
      color:'#999'
    }
  },
  hidden:{
    display:"none"
  },
  price:{
    padding: "3px 0px",
    marginTop: "15px",
    borderRadius: "10px",
    textAlign: "center",
    backgroundColor: "#f4f4f4"
  },
  sameSize:{
    minHeight:"100px"
  }
};

export default learningPageStyle;
